import { FunctionComponent as F } from "react";
import { useSelector } from "react-redux";
import { IState } from "../../../core/store/store";
import Folder, { Props as FolderProps } from "./Folder";





const FoldersList: F<FolderProps> = (props: FolderProps) =>
{
  const folders = useSelector((state: IState) =>
    state.protocol.folders.filter(f => f.parentFolderId === props.folderId));

  return (
    <>
      {folders.map((f, i) => <Folder
        {...props}
        folderId={f.folderId}
        key={i}/>)}
    </>);
}

export default FoldersList;